// extracted by mini-css-extract-plugin
export var caption = "_0cnp8tjUnxqrnbi_pQ2w";
export var heading = "SiEvaf20WVz4gIG7HaMg";
export var headingSkeleton = "vymnbK1uTobYXADb0x0D";
export var root = "j4rCvIaRxtWcQDkmMWlA";